import { NavigateFunction } from 'react-router'
import FFGFormNavigation from './FFGFormNavigation'
import SmavaFormNavigation from 'components/Smava/FormNavigation'
import FormNavigationEditPage from 'components/Smava/RceEdit/FormNavigtionEditPage'
import { useStores } from 'stores/utils/hooks/useStores'
import { observer } from 'mobx-react'
import { RCE_EDIT_PAGE_NAMES, PREFILL_PAGE_NAMES } from 'utils/pages'
import { PageText } from 'components/Smava/RceEdit/RCEEdit'
import PrefillFooter from 'components/AbTestComponents/CAT3834/PrefillFooter'
import PrefillFooterV2 from 'components/AbTestComponents/CAT4197/PrefillFooter'
import { CONFIG_DDF_CAT_4197_VAR_B } from 'config/utils/config'

interface Props {
  isSmava?: boolean
  onBack?: () => void
  onNext: () => void
  navigate: NavigateFunction
  isOfferLabel?: boolean
}

const FormNavigationSwitcher = observer((props: Props) => {
  const sharedProps = {
    onNext: props.onNext,
    onBack: props.onBack,
    navigate: props.navigate
  }

  const {
    page: { config },
    navigation: { currentPageInSession }
  } = useStores()

  const { isSmava, isOfferLabel } = props
  const isRCEEditPage =
    config.separateEditPage &&
    RCE_EDIT_PAGE_NAMES.includes(currentPageInSession || '')

  const isPrefillScreen = currentPageInSession
    ? PREFILL_PAGE_NAMES.includes(currentPageInSession)
    : false

  if (isRCEEditPage && currentPageInSession) {
    // @ts-ignore - PageText type needs refinement for dynamic access
    const continueButtonText = PageText[currentPageInSession]

    return (
      <FormNavigationEditPage
        {...sharedProps}
        continueButtonText={continueButtonText}
        isSmava={!!isSmava}
      />
    )
  }

  if (isPrefillScreen) {
    if (config.name === CONFIG_DDF_CAT_4197_VAR_B) {
      return (
        <PrefillFooterV2
          {...sharedProps}
          currentPageInSession={currentPageInSession}
          isSmava={!!isSmava}
        />
      )
    }
    return (
      <PrefillFooter
        {...sharedProps}
        currentPageInSession={currentPageInSession}
        continueButtonColor={isSmava ? 'primary' : 'secondary'}
        backButtonVariant={isSmava ? 'outlined' : 'text'}
        isSmava={!!isSmava}
      />
    )
  }

  if (isSmava) {
    return (
      <SmavaFormNavigation
        {...sharedProps}
        legalContact="info@smava.de"
        isOfferLabel={isOfferLabel}
      />
    )
  }

  return (
    <FFGFormNavigation {...sharedProps} legalContact="kredite@finanzcheck.de" />
  )
})

export { FormNavigationSwitcher }
